import * as React from 'react'

function IconFinish(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={30}
      height={37}
      viewBox="0 0 30 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#prefix__clip0)">
        <path
          d="M27.21 19.88H8.28c-.97 0-1.76-.79-1.76-1.76V3.26c0-.97.79-1.76 1.76-1.76h18.93c1.58 0 2.56 1.72 1.75 3.08l-3.03 5.07c-.38.64-.38 1.45 0 2.09l3.03 5.07c.81 1.35-.17 3.07-1.75 3.07z"
          fill="#E84E25"
        />
        <path
          d="M6.52 36.21c-.83 0-1.5-.67-1.5-1.5V1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v33.21c0 .83-.67 1.5-1.5 1.5z"
          fill="#000"
        />
        <path
          d="M11.54 36.21H1.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h10.04c.83 0 1.5.67 1.5 1.5s-.68 1.5-1.5 1.5z"
          fill="#000"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" d="M0 0h29.25v36.21H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IconFinish
